module.exports = __webpack_public_path__ + "img/diaceutics-brand-gradients-03.2db255e6.png";